/**
 * Standard reports that expose Schedule-only UI (no Columns/Filters/Parameters tabs).
 * Filters and columns are fixed on the report; tenant configures schedule + export only.
 */
export const STANDARD_SCHEDULE_REPORT_VALUES = [
  "cpi_payments_monthly_report",
  "add_and_cancel_cpi",
];

export const isStandardScheduleReport = (report) =>
  report?.type === "standard" &&
  STANDARD_SCHEDULE_REPORT_VALUES.includes(String(report?.value || "").trim());
